module.exports = __webpack_public_path__ + "static/media/LearnCreatorTryItPreview.2538669f.jpg";